import { render, staticRenderFns } from "./CreateContact.vue?vue&type=template&id=33374912&"
import script from "./CreateContact.vue?vue&type=script&lang=js&"
export * from "./CreateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports